module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.tournament) ? _c('div', [_c('md-card', [_c('md-card-area', {
    attrs: {
      "md-inset": ""
    }
  }, [_c('md-card-header', [_c('md-card-header-text', [_c('div', {
    staticClass: "md-title"
  }, [_c('img', {
    staticClass: "sport",
    attrs: {
      "src": _vm.icon(_vm.tournament)
    }
  }), _vm._v("\n            " + _vm._s(_vm.tournament.name) + "\n            "), _c('md-tooltip', [_vm._v(_vm._s(_vm.tournament.sport) + " - " + _vm._s(_vm.tournament.id))]), _vm._v(" "), _c('span', [(_vm.$apollo.loading) ? _c('md-progress-bar', {
    attrs: {
      "md-mode": "query"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "md-subhead"
  }, [_c('md-icon', [_vm._v("location_on")]), _vm._v(" "), _c('span', [_vm._v(_vm._s((_vm.tournament.location && _vm.tournament.location.name) || "unknown location"))])], 1), _vm._v(" "), _c('div', {
    staticClass: "md-subhead"
  }, [_c('md-icon', [_vm._v("date_range")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.tournamentDates))])], 1)]), _vm._v(" "), (_vm.isMine(_vm.tournament)) ? _c('md-menu', {
    attrs: {
      "md-size": "auto",
      "md-direction": "bottom-end"
    }
  }, [_c('md-button', {
    staticClass: "md-icon-button",
    attrs: {
      "md-menu-trigger": ""
    }
  }, [_c('md-icon', [_vm._v("more_vert")])], 1), _vm._v(" "), _c('md-menu-content', [_c('md-menu-item', [_c('span', [_vm._v("Generate draw")]), _vm._v(" "), _c('md-icon', [_vm._v("ac_unit")])], 1), _vm._v(" "), _c('md-menu-item', {
    staticClass: "md-inset md-accent",
    on: {
      "click": function($event) {
        _vm.showFriendlyKODialog = true
      }
    }
  }, [_vm._v("Friendly Knockout")]), _vm._v(" "), _c('md-menu-item', {
    staticClass: "md-inset",
    on: {
      "click": function($event) {
        _vm.showKODialog = true
      }
    }
  }, [_vm._v("Knockout")]), _vm._v(" "), _c('md-menu-item', {
    staticClass: "md-inset",
    on: {
      "click": function($event) {
        _vm.showRRDialog = true
      }
    }
  }, [_vm._v("Round Robin")]), _vm._v(" "), _c('md-divider', {
    staticClass: "md-inset"
  }), _vm._v(" "), _c('md-menu-item', {
    on: {
      "click": function($event) {
        _vm.showConfirmResetDraw = true
      }
    }
  }, [_c('span', [_vm._v("Reset draw")]), _vm._v(" "), _c('md-icon', [_vm._v("redo")])], 1), _vm._v(" "), _c('md-menu-item', {
    on: {
      "click": function($event) {
        _vm.showSimulationDialog = true
      }
    }
  }, [_c('span', [_vm._v("Simulate play")]), _vm._v(" "), _c('md-icon', [_vm._v("compare_arrows")])], 1), _vm._v(" "), (_vm.tournament.isPublic) ? _c('md-menu-item', {
    on: {
      "click": _vm.togglePublicity
    }
  }, [_c('span', [_vm._v("Make private")]), _vm._v(" "), _c('md-icon', [_vm._v("vpn_lock")])], 1) : _c('md-menu-item', {
    on: {
      "click": _vm.togglePublicity
    }
  }, [_c('span', [_vm._v("Make public")]), _vm._v(" "), _c('md-icon', [_vm._v("public")])], 1), _vm._v(" "), _c('md-divider', {
    staticClass: "md-inset"
  }), _vm._v(" "), _c('md-menu-item', {
    on: {
      "click": function($event) {
        _vm.showEditTournamentDialog = true
      }
    }
  }, [_c('span', [_vm._v("Edit")]), _vm._v(" "), _c('md-icon', [_vm._v("edit")])], 1), _vm._v(" "), _c('md-menu-item', {
    on: {
      "click": function($event) {
        _vm.showConfirmDelete = true
      }
    }
  }, [_c('span', [_vm._v("Delete")]), _vm._v(" "), _c('md-icon', [_vm._v("delete")])], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('md-card-content', [_vm._v(_vm._s(_vm.tournament.description))]), _vm._v(" "), _c('md-card-actions', [(_vm.tournament.format) ? _c('md-chip', [_c('md-icon', [_vm._v("ac_unit")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.truncate(_vm.tournament.format, 8)))]), _vm._v(" "), _c('md-tooltip', [_vm._v("Tournament format - " + _vm._s(_vm.tournament.format))])], 1) : _vm._e(), _vm._v(" "), (_vm.tournament.isPublic) ? _c('md-chip', {
    staticClass: "md-primary"
  }, [_c('md-icon', [_vm._v("public")]), _vm._v(" "), _c('span', [_vm._v("Public")]), _vm._v(" "), _c('md-tooltip', [_vm._v("This tournament is visible to the public")])], 1) : _c('md-chip', {
    staticClass: "md-accent"
  }, [_c('md-icon', [_vm._v("vpn_lock")]), _vm._v(" "), _c('span', [_vm._v("Private")]), _vm._v(" "), _c('md-tooltip', [_vm._v("Only you can see this tournament")])], 1), _vm._v(" "), _c('md-button', {
    staticClass: "md-icon-button",
    on: {
      "click": _vm.refetch
    }
  }, [_c('md-icon', [_vm._v("refresh")])], 1)], 1)], 1), _vm._v(" "), _c('md-card-content', [_c('md-tabs', [_c('md-tab', {
    attrs: {
      "id": "tab-matches",
      "md-label": _vm.matchesTabTitle(_vm.tournament),
      "md-icon": "play_circle_outline"
    }
  }, [_c('TournamentMatches', {
    attrs: {
      "tournament": _vm.tournament
    }
  })], 1), _vm._v(" "), _c('md-tab', {
    attrs: {
      "id": "tab-diagram",
      "md-icon": "playlist_play",
      "md-label": _vm.flightsTabTitle(_vm.tournament)
    }
  }, [_c('TournamentFlights', {
    attrs: {
      "tournament": _vm.tournament
    }
  })], 1), _vm._v(" "), _c('md-tab', {
    attrs: {
      "id": "tab-competitors",
      "md-label": _vm.competitorsTabTitle(_vm.tournament),
      "md-icon": "people"
    }
  }, [_c('TournamentCompetitors', {
    attrs: {
      "tournament": _vm.tournament
    }
  })], 1), _vm._v(" "), _c('md-tab', {
    attrs: {
      "id": "tab-details",
      "md-icon": "details"
    }
  }, [_c('TournamentDetails', {
    attrs: {
      "tournament": _vm.tournament
    }
  })], 1), _vm._v(" "), (_vm.isMine(_vm.tournament)) ? _c('md-tab', {
    attrs: {
      "id": "tab-venues",
      "md-icon": "gps_fixed"
    }
  }, [_c('TournamentVenues', {
    attrs: {
      "tournament": _vm.tournament
    }
  })], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('GenerateKODrawDialog', {
    attrs: {
      "tournament": _vm.tournament,
      "show": _vm.showKODialog
    },
    on: {
      "onClose": function($event) {
        _vm.showKODialog = false
      }
    }
  }), _vm._v(" "), _c('GenerateFriendlyKODrawDialog', {
    attrs: {
      "tournament": _vm.tournament,
      "show": _vm.showFriendlyKODialog
    },
    on: {
      "onClose": function($event) {
        _vm.showFriendlyKODialog = false
      }
    }
  }), _vm._v(" "), _c('GenerateRRDrawDialog', {
    attrs: {
      "tournament": _vm.tournament,
      "show": _vm.showRRDialog
    },
    on: {
      "onClose": function($event) {
        _vm.showRRDialog = false
      }
    }
  }), _vm._v(" "), _c('SimulatePlayDialog', {
    attrs: {
      "tournament": _vm.tournament,
      "show": _vm.showSimulationDialog
    },
    on: {
      "onClose": function($event) {
        _vm.showSimulationDialog = false
      }
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    attrs: {
      "md-active": _vm.showConfirmResetDraw,
      "md-title": "Reset draw?",
      "md-content": "Resetting the draw will delete all matches from the tournament... forever!",
      "md-confirm-text": "Confirm",
      "md-cancel-text": "Cancel"
    },
    on: {
      "update:mdActive": function($event) {
        _vm.showConfirmResetDraw = $event
      },
      "md-confirm": _vm.resetDraw
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    attrs: {
      "md-active": _vm.showConfirmDelete,
      "md-title": "Delete tournament?",
      "md-content": "Delete the tournament and all its matches and competitors forever!",
      "md-confirm-text": "Confirm",
      "md-cancel-text": "Cancel"
    },
    on: {
      "update:mdActive": function($event) {
        _vm.showConfirmDelete = $event
      },
      "md-confirm": _vm.deleteTournament
    }
  }), _vm._v(" "), _c('UpsertTournamentDialog', {
    attrs: {
      "show": _vm.showEditTournamentDialog,
      "tournament": _vm.tournament
    },
    on: {
      "onClose": function($event) {
        _vm.showEditTournamentDialog = false
      }
    }
  })], 1) : _c('div', [_c('md-progress-spinner', {
    staticClass: "wait",
    attrs: {
      "md-diameter": 100,
      "md-stroke": 10,
      "md-mode": "indeterminate"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5caa2c71","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tournament.vue
// module id = 448
// module chunks = 1